module.exports = __webpack_public_path__ + "static/media/screen_4.fb5ba8f2.png";